(function() {
    'use strict';

    angular.module('ksef.constants', [])
        .constant('ksefCompanyMessagesConst', {
            add: 'Firma została dodana!',
            update: 'Dane firmy zostały zaktualizowane!',
            activationSuccess: 'Połączenie z KSeF zostało aktywowane!',
            activationError: 'Nie udało się aktywować połączenia z KSeF!',
            error: 'Wystąpił błąd podczas dodawania firmy!',
            delete: 'Firma została usunięta!'
        })
        .constant('ksefCompanyPermissionsConst', {
            view: {
                value: 'view_ksefcompany',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu firmy!'
            },
            add: {
                value: 'add_ksefcompany',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania firmy!'
            },
            update: {
                value: 'change_ksefcompany',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji firmy!'
            },
            delete: {
                value: 'delete_ksefcompany',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania firmy!'
            }
        })
        .constant('ksefCertificateMessagesConst', {
            add: 'Certyfikat został dodany!',
            update: 'Certyfikat został zaktualizowany!',
            error: 'Wystąpił błąd podczas dodawania certyfikatu!',
            delete: 'Certyfikat została usunięta!',
            deleteError: 'Wystąpił błąd podczas usuwania certyfikatu!'
        })
        .constant('ksefCertificatePermissionsConst', {
            view: {
                value: 'view_ksefcertificate',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu certyfikatu!'
            },
            add: {
                value: 'add_ksefcertificate',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania certyfikatu!'
            },
            update: {
                value: 'change_ksefcertificate',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji certyfikatu!'
            },
            delete: {
                value: 'delete_ksefcertificate',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania certyfikatu!'
            }
        });
})();
